<app-nav class="w-100"></app-nav>
<div class="banner-bredcrum">
  <section class="banner">
    <div #air id="air" class="air"></div>
    <div class="head-component-ui">
      <div class="searchbar" data-aos="fade-down">
        <div class="hometitle mob-view">
          <span class="sstarabicbold search-txt">
            {{ "Knowledge gate" | translator }}
          </span>
          <span class="sstarabicbold header-capsoul">
            <div class="pi pi-times-circle" routerLink="/home" style="cursor: pointer"></div>
  
            <i class="pi pi-book m-l-2 m-r-2" style="font-size: 1rem" aria-hidden="true"></i>
            {{ "KL approval" | translator }}
          </span>
        </div>
  
        <div class="">
          <div class="" style="position: relative">
            <form (ngSubmit)="handleSubmit($event)">
              <span class="p-input-icon-right w-100">
                <i class="pi pi-search" style="width: 30px"></i>
                <input filterButton pInputText name="search"
                  class="form-control header-input-ui" type="text" dir="rtl"
                  [(ngModel)]="searchFilterValue" (input)="onInputChange($event)"
                  placeholder="{{ 'Research' | translator }}" />
              </span>
            </form>
          </div> 
        </div>
      </div>
    </div>
  </section>
</div>

<section class="knowledgeLibrarySection container-fluid" #target *ngIf="!preloader">
  <div class="max-width-1700">
      <div class="row">
        <div class="col-lg-2 col-md-4 col-12 my-2 ppp-dropdown">
          <p-dropdown
            styleClass="w-100 h-100"
            optionLabel="name"
            placeholder="{{ 'Choose an organizational unit' | translator }}" 
            [filter]="true"
          >
            <ng-template let-node pTemplate="default">
              <div class="d-flex">
                <img
                  src="https://plus.unsplash.com/premium_photo-1706344618667-7135607ad235?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw3fHx8ZW58MHx8fHx8"
                  class="img-fluid p-1"
                  style="max-height: 30px; max-width: 30px"
                />
                <ng-template #elseBlock>
                  <i class="{{ node.image }} p-2" style="font-size: 1rem"></i>
                </ng-template>
                <b class="text-nowrap">{{ node.name }}</b>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="col-lg-2 col-md-4 col-12 my-2">
          <p-calendar appendTo="body" dir="ltr" class="ppp-calander" [showIcon]="true" selectionMode="range" [readonlyInput]="true"
            [(ngModel)]="dateFilter" placeholder="{{ 'Date' | translator }}"
            (ngModelChange)="getKlRequests()"></p-calendar>
        </div>
        <div class="col-lg-2 col-md-4 col-12 d-flex justify-content-start my-2">
          <button class="ms-library" icon="pi pi-rotate-right" (click)="refreshFilters()">
            {{ "Reset" | translator }}
          </button>
          <div class="col-4">
            <!-- <button class="ms-library">
              <i class="pi pi-clone"></i>
            </button> -->
          </div>
        </div>
        <h5 class="text-start btn-sbc mx-3 mb-0">
          {{ "Categories" | translator }}&nbsp;<i class="fa fa-chevron-circle-down"></i>
        </h5>
      </div>
      <div class="row">
        <div class="col-md-4 col-12 my-2">
          <div class="grey-box h-webkit">
      <div class="col-md-12 col-12 my-2">
        <a class="w-100 decoration-none">
          <button class="decoration-none w-100 d-flex gap-2 text-decoration-none justify-content-center {{
                      logStatus == 'PENDING' ? 'ms-btnn' : 'ppp-ms'
                    }}" (click)="logStatus = 'PENDING';getKlRequests()">

            <i class="pi pi-exclamation-triangle text-decoration-none" aria-hidden="true"></i>
            <span>{{'PENDING' | translator}}</span>
          </button>
        </a>
      </div>
      <div class="col-md-12 col-12 my-2">
        <a class="w-100 decoration-none">
          <button class="decoration-none w-100 d-flex gap-2 text-decoration-none justify-content-center {{
                        logStatus =='APPROVED' ? 'ms-btnn' : 'ppp-ms' }}"
            (click)="logStatus ='APPROVED';getKlRequests()">
            <i class="pi pi-check-circle text-decoration-none" aria-hidden="true"></i>
            <span>{{'APPROVED' | translator}}</span>
          </button>
        </a>
      </div>
      <div class="col-md-12 col-12 my-2">
        <a class="w-100 decoration-none">
          <button class="decoration-none w-100 d-flex gap-2 text-decoration-none justify-content-center {{
                        logStatus == 'REJECTED' ? 'ms-btnn' : 'ppp-ms' }}"
            (click)="logStatus = 'REJECTED';getKlRequests()">
            <i class="fa-solid fa-xmark text-decoration-none" aria-hidden="true"></i>
            <span>{{'REJECTED' | translator}}</span>
          </button>
        </a>
      </div>
    </div>
    </div>
      <!--  -->
      <!-- <div class="col-12 col-md-12 py-1 ppp-dropdown">
        <p-dropdown
          styleClass="w-100 h-100"
          placeholder="{{ 'Types of files' | translator }}"
        ></p-dropdown>
      </div> -->
      <!--  -->
      <div class="col-md-8 col-12">
        <div class="row">
          <ng-container *ngFor="let request of libraryRequests">
            <div (click)="openCourseData(request)" class="col-lg-4 col-md-6 col-sm-6 col-12 hover-card my-2 p-0 87878"
              role="button">
              <div class="px-1 h-webkit">
                <!-- custom card  -->
                <div class="card card-bg-v4 h-webkit">
                  <div class="headerr">
                    <!-- <img class="icon-img" src="https://images.unsplash.com/photo-1707391464204-47fa6cc35d22?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzfHx8ZW58MHx8fHx8" /> -->
                    <div class="heading d-flex justify-content-between w-100">
                      <div class="">
                        <h6 class="title">
                          {{request?.title}}
                        </h6>
                        <p *ngIf="request.status == 'REJECTED' " class="description">{{'Rejected by'|translator}} :
                          {{request?.approvedBy?.name?.first}} {{request?.approvedBy?.name?.middle}}
                          {{request?.approvedBy?.name?.last}}</p>
                          <p class="description">{{'created by'|translator}} : {{request?.createdBy?.name?.first}}
                            {{request?.createdBy?.name?.middle}} {{request?.createdBy?.name?.last}}</p>
                          <p *ngIf="request.status == 'APPROVED' " class="description">{{'Approved by'|translator}} :
                            {{request?.approvedBy?.name?.first}} {{request?.approvedBy?.name?.middle}}
                            {{request?.approvedBy?.name?.last}}</p>
                      </div>
                      <div class="">
                        <span class="description-date my-2"> {{request?.createdAt | date}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="img">
                    <img class="center-img" alt="" src='{{staticURL+request?.data?.image }}' />
                  </div>
                  <div class="crd-footer py-2">
                    <a class="my-2 deco" [innerHTML]="request?.data?.description"></a>
                    <!-- <span class="description-date my-2"> {{request?.createdBy | date}}</span> -->
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- TODO: List View Goes Here -->
        <ng-template #listView>
          <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-6 col-12 hover-card my-2" role="button">
              <div class="px-1">
                <!-- custom card 2 -->
                <div class="card card-shaddow card-bg-v4">
                  <div class="headerr-2">
                    <div class="heading mx-2">
                      <h6 class="title">
                        mulla work
                      </h6>
                      <hr />
                      <div class="row">
                        <div class="col p-0">
                          <div class="d-flex align-items-center">
                            <img class="icon-img-3"
                              src="https://images.unsplash.com/photo-1709065397155-1cd979c61fac?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw0fHx8ZW58MHx8fHx8" />
                            <p class="description">name mulla 2</p>
                          </div>
                        </div>
                        <!-- <div class="col-6 p-0">
                            <p class="m-0 tiny-text">{{"Aphtrafts"| translator}}</p>
                          </div> -->
                      </div>
                    </div>
                    <img class="icon-img-2"
                      src="https://images.unsplash.com/photo-1709065397155-1cd979c61fac?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw0fHx8ZW58MHx8fHx8"
                      alt="loading..." />
                  </div>
                  <div class="crd-footer px-2 pb-2">
                    <a class="my-2 deco">hellow mulla G</a>
                    <span class="description-date my-2">10/12/2015</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <app-no-data *ngIf="this.libraryRequests?.length <=0"></app-no-data>
</section>

<app-skelitions [hidden]="!preloader" [value]="4"></app-skelitions>
<!-- <section class="faqsection">
  <h1 class="sstarabicbold" style="color: white">
    <i class="fa fa-question-circle-o" aria-hidden="true"></i>
    {{ "Add new data" | translator }}
  </h1>

  <p class="sstarabic mobile-text" style="color: white; padding: 10px 18px">
    {{
      "You can add more information by clicking the button below" | translator
    }}
  </p>

  <button
    class="btn btn-sbc sstarabicbold"
    routerLink="/dashboard/knowledge-library"
    style="padding-left: 20px; padding-right: 20px"
  >
    {{ "Press here" | translator }}
  </button>
</section> -->


<p-dialog header="{{'Add to Kl'| translator}}" [(visible)]="openAddKLModal" [style]="{width: '90vw'}">
  <app-add-training-kl *ngIf="openAddKLModal" [requestData]="courseRequestHolder"
    (submitSucces)="librarySubmit($event)"></app-add-training-kl>
</p-dialog>

<app-footer></app-footer>